import styled from 'styled-components';

const CategorySelect = styled.select`
    margin : 10px 0;
    padding : 10px;
    border : 1px solid #d3d3d3;
`;

export default CategorySelect;
